export interface HotItem {
  id: number;
  tag: string;
  title: string;
  votes: number;
  delta: string;
  trend: 'up' | 'down' | 'flat';
  hot: number;
}

export interface PkOption {
  name: string;
  desc: string;
  votes: number;
}

export interface PkPair {
  id: number;
  theme: string;
  a: PkOption;
  b: PkOption;
}

export interface AbsurdPoll {
  id: number;
  question: string;
  category: string;
  option: string;
  ratio: number;
  votes: number;
  cover: string;
}

export interface NewsItem {
  id: number;
  tag: string;
  title: string;
  summary: string;
  reads: string;
  cover: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export interface QuoteItem {
  text: string;
  name: string;
  role: string;
}

export const tickerNews = [
  '今日 12:40｜顶流舞台神级救场冲上热榜，评论区已吵翻',
  '今日 11:05｜塌房网红道歉信被扒文案模板，网友在线考古',
  '今日 09:30｜年度综艺名场面投票突破百万，战况胶着',
  '昨日 22:18｜宠物界顶流"橘座"票数反超，暂居萌宠榜首',
  '昨日 20:02｜离谱投票榜首惊现"用微波炉加热可乐"，票选数惊人',
  '昨日 16:44｜网友票选年度最离谱颁奖现场，候选名单更新',
];

export const hotList: HotItem[] = [
  { id: 1, tag: '年度现场', title: '最离谱颁奖现场：奖项没颁错，反而更好笑', votes: 386400, delta: '+12.6万', trend: 'up', hot: 99 },
  { id: 2, tag: '综艺名场面', title: '甜综CP在后台背词名场面，正主率先开麦', votes: 351200, delta: '+9.8万', trend: 'up', hot: 97 },
  { id: 3, tag: '网红塌房', title: '头部网红道歉信现"标准句式"，网友开启考古', votes: 298600, delta: '+8.4万', trend: 'up', hot: 95 },
  { id: 4, tag: '影视角色', title: '反派配角演技封神，票选力压主角成年度意难平', votes: 247300, delta: '+6.1万', trend: 'up', hot: 92 },
  { id: 5, tag: '体坛名场面', title: '退役选手赛后采访笑场三连，弹幕名场面预定', votes: 198500, delta: '+4.7万', trend: 'up', hot: 88 },
  { id: 6, tag: '生活迷惑', title: '网友票选最离谱合租经历，结局竟如此暖心', votes: 162400, delta: '+3.2万', trend: 'up', hot: 84 },
  { id: 7, tag: '萌宠顶流', title: '"橘座"猫咪凭表情包蝉联萌宠榜人气第一', votes: 137800, delta: '+2.9万', trend: 'flat', hot: 80 },
  { id: 8, tag: '综艺名场面', title: '这季脱口秀爆梗盘点，观众直呼"我的嘴替"', votes: 114200, delta: '+1.8万', trend: 'down', hot: 76 },
];

export const pkPairs: PkPair[] = [
  {
    id: 1,
    theme: '年度综艺 · 名场面对决',
    a: { name: '爆笑接梗王', desc: '临场反应封神，一开口就是金句', votes: 284000 },
    b: { name: '催泪共情王', desc: '一句话让全场安静，泪点担当', votes: 241500 },
  },
  {
    id: 2,
    theme: '影视 · 年度反派谁更带感',
    a: { name: '疯批美人反派', desc: '狠得让人又恨又爱', votes: 193800 },
    b: { name: '沉默大佬反派', desc: '话少但压迫感拉满', votes: 221300 },
  },
  {
    id: 3,
    theme: '网红圈 · 谁更经得起考古',
    a: { name: '早年"黑历史"艺术家', desc: '越考古越好笑，历久弥新', votes: 157200 },
    b: { name: '稳定输出老选手', desc: '多年人设稳如泰山', votes: 178400 },
  },
  {
    id: 4,
    theme: '萌宠 · 谁是今日顶流',
    a: { name: '高冷布偶猫', desc: '颜值天花板，营业全靠眼神', votes: 132600 },
    b: { name: '傻白甜金毛', desc: '热情满分，笑容治愈全场', votes: 145900 },
  },
];

export const categories = ['全部', '综艺', '影视', '网红', '萌宠', '体育', '生活'];

export const absurdPolls: AbsurdPoll[] = [
  {
    id: 1,
    question: '以下哪种"迷惑行为"最让你看不下去？',
    category: '迷惑行为',
    option: '高票选项',
    ratio: 34,
    votes: 48200,
    cover: 'https://readdy.ai/api/search-image?query=Playful%203D%20illustration%20of%20a%20giant%20smartphone%20leaning%20over%20a%20tiny%20surprised%20person%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20soft%20studio%20lighting%2C%20quirky%20funny%20meme%20energy%2C%20editorial%20vector%20art&width=900&height=720&seq=absurd-01&orientation=portrait',
  },
  {
    id: 2,
    question: '年度最离谱"带饭"行为是什么？',
    category: '生活迷惑',
    option: '高票选项',
    ratio: 41,
    votes: 39100,
    cover: 'https://readdy.ai/api/search-image?query=Cute%203D%20illustration%20of%20a%20lunchbox%20with%20eyes%20and%20tiny%20arms%20running%20away%20from%20a%20fork%2C%20warm%20amber%20and%20coral%20tones%2C%20soft%20shadows%2C%20whimsical%20comedy%20style%2C%20editorial%20render&width=900&height=720&seq=absurd-02&orientation=portrait',
  },
  {
    id: 3,
    question: '这段"神仙救场"现场，你站谁？',
    category: '综艺名场面',
    option: '高票选项',
    ratio: 37,
    votes: 35600,
    cover: 'https://readdy.ai/api/search-image?query=Vibrant%203D%20illustration%20of%20a%20microphone%20and%20spotlight%20with%20sparkles%20and%20confetti%2C%20warm%20coral%20gold%20green%20palette%2C%20energetic%20stage%20energy%2C%20soft%20glow%2C%20editorial%20style&width=900&height=720&seq=absurd-03&orientation=portrait',
  },
  {
    id: 4,
    question: '史上最离谱"假期作业"长这样？',
    category: '迷惑行为',
    option: '高票选项',
    ratio: 45,
    votes: 32900,
    cover: 'https://readdy.ai/api/search-image?query=Cute%203D%20illustration%20of%20a%20stack%20of%20colorful%20notebooks%20with%20a%20sleepy%20face%20crying%20tiny%20tears%20under%20a%20desk%20lamp%2C%20warm%20amber%20and%20coral%20tones%2C%20whimsical%20relatable%20mood%2C%20editorial%20render&width=900&height=720&seq=absurd-04&orientation=portrait',
  },
];

export const newsList: NewsItem[] = [
  {
    id: 1,
    tag: '深度观察',
    title: '为什么"吃瓜投票"能让人刷到停不下来？',
    summary: '从投票心理到话题热度，拆解这场席卷全网的"人气PK"狂欢背后，人们究竟在投什么。',
    reads: '12.6万次阅读',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20editorial%203D%20illustration%20of%20a%20row%20of%20cute%20melons%20with%20different%20facial%20expressions%20holding%20tiny%20ballot%20boxes%2C%20coral%20amber%20cream%20palette%2C%20soft%20studio%20light%2C%20fun%20voting%20concept%2C%20high%20detail&width=1400&height=900&seq=news-01&orientation=landscape',
  },
  {
    id: 2,
    tag: '榜单战报',
    title: '年度综艺名场面Top10出炉，第一名实至名归',
    summary: '历经72小时网友票选，人气PK结果揭晓，从爆笑救场到催泪神级发言，你最爱的上榜了吗？',
    reads: '9.2万次阅读',
    cover: 'https://readdy.ai/api/search-image?query=Glossy%203D%20trophy%20and%20golden%20crown%20on%20a%20podium%20with%20confetti%20and%20stage%20lights%2C%20warm%20gold%20coral%20cream%20palette%2C%20celebration%20mood%2C%20soft%20glow%2C%20editorial%20style%2C%20high%20detail&width=1400&height=900&seq=news-02&orientation=landscape',
  },
  {
    id: 3,
    tag: '考古现场',
    title: '塌房道歉信里的"标准句式"，为什么让人更来气？',
    summary: '网友在线逐句考古，拆解网红道歉信的套路化表达，也聊聊真诚回应到底长什么样。',
    reads: '8.1万次阅读',
    cover: 'https://readdy.ai/api/search-image?query=Warm%203D%20illustration%20of%20a%20magnifying%20glass%20inspecting%20an%20open%20letter%20document%2C%20coral%20amber%20cream%20palette%2C%20curious%20sleuth%20mood%2C%20soft%20shadows%2C%20editorial%20style%2C%20high%20detail&width=1400&height=900&seq=news-03&orientation=landscape',
  },
  {
    id: 4,
    tag: '弹幕精选',
    title: '盘点今年弹幕神评论，网友个个都是"嘴替"',
    summary: '有人负责造梗，有人负责共情，还有人一句话终结比赛。这一年，弹幕里的名场面不比正片少。',
    reads: '7.4万次阅读',
    cover: 'https://readdy.ai/api/search-image?query=Vibrant%203D%20illustration%20of%20floating%20chat%20bubbles%20and%20message%20boxes%20in%20warm%20coral%20gold%20colors%2C%20screen%20commentary%20mood%2C%20playful%20dynamic%20layout%2C%20soft%20glow%2C%20editorial%20style%2C%20high%20detail&width=1400&height=900&seq=news-04&orientation=landscape',
  },
  {
    id: 5,
    tag: '萌宠顶流',
    title: '这只"橘座"凭什么蝉联萌宠人气第一？',
    summary: '一张表情包走红后持续营业，票选数据一路走高。铲屎官们说：别问，问就是颜值加实力。',
    reads: '6.6万次阅读',
    cover: 'https://readdy.ai/api/search-image?query=Cute%203D%20illustration%20of%20a%20chubby%20orange%20cat%20wearing%20a%20tiny%20golden%20crown%20sitting%20proudly%2C%20warm%20amber%20cream%20coral%20palette%2C%20soft%20lighting%2C%20adorable%20mood%2C%20editorial%20render%2C%20high%20detail&width=1400&height=900&seq=news-05&orientation=landscape',
  },
  {
    id: 6,
    tag: '榜单观察',
    title: '榜单实时更新的秘密：每票都算数，公平看得见',
    summary: '从投票计数到结果展示，聊聊榜单如何做到透明、可追踪，让每一位网友的票都不被辜负。',
    reads: '5.9万次阅读',
    cover: 'https://readdy.ai/api/search-image?query=Clean%203D%20illustration%20of%20a%20voting%20interface%20with%20rising%20bar%20chart%20and%20checkmark%2C%20warm%20coral%20green%20cream%20palette%2C%20transparent%20trustworthy%20mood%2C%20soft%20light%2C%20editorial%20style%2C%20high%20detail&width=1400&height=900&seq=news-06&orientation=landscape',
  },
];

export const faqList: FaqItem[] = [
  {
    q: '吃瓜榜单的投票是实时更新的吗？',
    a: '是的。每当你投出一票或刷新榜单，人气数据都会即时同步刷新，上榜热度和票数随真实参与不断变化，你的每一次选择都会真实地影响榜单走向。',
  },
  {
    q: '我的一票真的能改变名次吗？',
    a: '当然。榜单名次完全由实时票数决定，热门PK差距往往只有几千票，而一次全网刷屏可能带来几十万票的涌入。别小看自己那一票，它可能正是压垮天平的最后一块瓜皮。',
  },
  {
    q: '如何参与人气PK和离谱投票？',
    a: '在"人气PK"和"离谱投票"板块，点击你支持的选项并确认即可完成投票。每个话题可投一票，投完可实时查看支持率变化，并通过"查看战报"了解双方的支持分布。',
  },
  {
    q: '吃瓜榜单的内容是怎么来的？',
    a: '榜单内容由编辑团队结合实时热点、网友热议与公开投票动态整理而成。我们坚持只做话题聚合与票选记录，不编造细节、不替网友下结论，呈现的是大家真实的关注与选择。',
  },
  {
    q: '我有想上榜的话题或投票想法，如何提交？',
    a: '欢迎通过页面底部邮箱与我们联系，附上话题说明与投票创意。被采纳的选题会进入候选池，通过初步审核后即可发起新的网友票选。',
  },
];

export const quoteList: QuoteItem[] = [
  {
    text: '本来是来吃瓜的，结果把我整得天天来投票打卡，榜单是真上头。',
    name: '一位资深吃瓜群众',
    role: '注册吃瓜用户',
  },
  {
    text: '每次刷新都有新名次，能看到自己支持的选项一点点涨上去，参与感拉满。',
    name: '榜首见证者',
    role: '连续打卡30天',
  },
  {
    text: '离谱投票真的是我的快乐源泉，评论区比正片还好笑，必须安利。',
    name: '快乐搭子',
    role: '热心票友',
  },
];

export const statItems = [
  { label: '累计有效票数', value: '2.18亿+' },
  { label: '覆盖热榜话题', value: '460+' },
  { label: '参与投票网友', value: '3120万+' },
  { label: '每日实时榜单', value: '24条' },
];